import React from "react";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import SubLabel from "components/Atoms/Sublabel";
import { getCityStateCountry } from "shared/utils/addressUtils";

const perPage = 20;

interface CompanyListProps extends MultiPickerListProps<server.dto.CompanySmall> {
  addressType: server.dto.AddressTypes;
}

const MultiCompanyList = (props: CompanyListProps) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedCompanyInstruction>({
    keyword: "",
    page: 1,
    perPage: perPage,
  });

  return <MultiPickerListWithSelectedItems
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="companylist"
    api={(instruction) => window.CoreApi.Company.PaginatedSmall(instruction, props.addressType)}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    renderListItem={company => <div>
      <div>{company.name}</div>
      <SubLabel>{getCityStateCountry(company.address)}</SubLabel>
    </div>}
    getId={company => company.companyId}
    getLabel={company => <div>{company.name}</div>}
    value={props.value}
  />
};

export default MultiCompanyList;